import ApiBase from '../ApiBase';

export default new class extends ApiBase {
    route = 'push-notifications/:push_notification/logs';
};
